import { CreditCard, ReceiptText, Briefcase, Home, Zap, Car, type LucideIcon } from "lucide-react";

export interface AssetSearchOption {
  id: string;
  label: string;
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
}

export const ASSET_SEARCH_OPTIONS: AssetSearchOption[] = [
  {
    id: "debts-accounts",
    label: "Debts & Accounts",
    icon: CreditCard,
    iconBg: "bg-blue-50",
    iconColor: "text-blue-500",
  },
  {
    id: "tax-history",
    label: "Tax History",
    icon: ReceiptText,
    iconBg: "bg-orange-50",
    iconColor: "text-orange-500",
  },
  {
    id: "employment-benefits",
    label: "Employment & Benefits",
    icon: Briefcase,
    iconBg: "bg-indigo-50",
    iconColor: "text-indigo-500",
  },
  {
    id: "property-records",
    label: "Property Records",
    icon: Home,
    iconBg: "bg-purple-50",
    iconColor: "text-purple-500",
  },
  {
    id: "utilities-phone",
    label: "Utilities & Phone",
    icon: Zap,
    iconBg: "bg-green-50",
    iconColor: "text-green-600",
  },
  {
    id: "vehicle-records",
    label: "Vehicle Records",
    icon: Car,
    iconBg: "bg-red-50",
    iconColor: "text-red-400",
  },
];
